import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { Square, CheckSquare, Layers } from "lucide-react";

// Promise-based "apply to which captions?" prompt used by every preset / effect / animation apply.
let opener = null;
export const askApplyScope = (opts) => (opener ? opener(opts) : Promise.resolve("all"));

export default function ApplyScopeDialog() {
  const [req, setReq] = useState(null); // { what, current, selected, total, resolve }
  useEffect(() => {
    opener = (opts) => new Promise((resolve) => setReq({ ...opts, resolve }));
    return () => { opener = null; };
  }, []);
  const done = (v) => { req?.resolve(v); setReq(null); };
  const opts = req ? [
    ["current", Square, "This caption", req.current ? `“${String(req.current).slice(0, 40)}”` : "No caption selected or under the playhead", !req.current],
    ["selected", CheckSquare, `Selected captions (${req.selected || 0})`, req.selected ? "The captions you picked" : "Use Select in the timeline header to pick captions", !req.selected],
    ["all", Layers, `All captions (${req.total || 0})`, "Every caption on every layer", !req.total],
  ] : [];
  return (
    <Dialog open={!!req} onOpenChange={(o) => { if (!o) done(null); }}>
      <DialogContent noSearch onOpenAutoFocus={(e) => e.preventDefault()} className="max-w-sm border-white/10 bg-[#121212]" data-testid="apply-scope-dialog">
        <DialogTitle className="font-display text-base font-black">Apply {req?.what ? `“${req.what}”` : "this"} to…</DialogTitle>
        <div className="space-y-2">
          {opts.map(([k, Icon, label, hint, dis]) => (
            <button key={k} disabled={dis} onClick={() => done(k)} data-testid={`apply-scope-${k}`}
              className="flex w-full items-center gap-3 rounded-xl border border-white/10 bg-white/[0.02] px-3 py-2.5 text-left transition-colors hover:border-[#00F0FF]/60 hover:bg-[#00F0FF]/5 disabled:cursor-not-allowed disabled:opacity-40">
              <Icon size={18} className="shrink-0 text-[#00F0FF]" />
              <span className="min-w-0"><span className="block text-sm font-semibold text-white">{label}</span><span className="block truncate text-[11px] text-[#A1A1AA]">{hint}</span></span>
            </button>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
